export const teamMembers = [
  {
    name: "K. Ramesh",
    role: "Founder & Managing Director",
    experience: "20+ years",
    bio: "Started Lahari in 2009 with two trucks and a simple promise: treat every customer's belongings like your own. Leads overall operations and client relationships.",
    icon: "ri-user-star-line",
  },
  {
    name: "Lakshmi Ramesh",
    role: "Co-Founder & Director, Operations",
    experience: "10+ years",
    bio: "Manages scheduling, crew allocation and quality checks across every Bangalore zone. Believes a good move is a planned move.",
    icon: "ri-user-heart-line",
  },
  {
    name: "Anand Kumar",
    role: "Head of Packing Operations",
    experience: "12+ years",
    bio: "Trains every packing crew on multi-layer wrapping, fragile handling and palletising techniques for households and corporate clients.",
    icon: "ri-box-3-line",
  },
  {
    name: "Sudhir Nair",
    role: "Logistics & Fleet Manager",
    experience: "11+ years",
    bio: "Plans routes across Bangalore, Mysore and Tumkur, maintains the covered-body fleet and ensures on-time loading and delivery windows.",
    icon: "ri-truck-line",
  },
  {
    name: "Priya Deshpande",
    role: "Customer Relations Manager",
    experience: "9+ years",
    bio: "Your single point of contact from estimate to delivery. Handles queries, rescheduling and post-move follow-ups on our 24x7 helpline.",
    icon: "ri-customer-service-2-line",
  },
  {
    name: "M. Ganesh",
    role: "Warehouse & Storage In-charge",
    experience: "13+ years",
    bio: "Oversees storage intake, inventory receipts and pest control at our Bangalore warehouse so stored goods stay dry and dust-free.",
    icon: "ri-store-3-line",
  },
  {
    name: "Ravi Shankar",
    role: "Senior Packing Supervisor",
    experience: "10+ years",
    bio: "Leads on-site crews for large household and multi-floor office shifts. Known for careful handling of glassware and modular furniture.",
    icon: "ri-hammer-line",
  },
  {
    name: "Sneha Rao",
    role: "Quality & Claims Support",
    experience: "7+ years",
    bio: "Audits completed moves, records feedback and resolves any transit concerns quickly with transparent follow-up.",
    icon: "ri-shield-check-line",
  },
];

export const teamValues = [
  {
    icon: "ri-team-line",
    title: "Trained, Uniformed Crews",
    text: "Every member is background-checked, uniformed and trained on the packing standards we use for each item category.",
  },
  {
    icon: "ri-award-line",
    title: "20+ Years On The Road",
    text: "Since 2009 our teams have handled over 500 moves across Bangalore, Mysore and Tumkur without cutting corners.",
  },
  {
    icon: "ri-heart-3-line",
    title: "Respect For Your Home",
    text: "We cover floors, protect walls and doorways, and leave your old and new home clean after the move.",
  },
];

export const crewPhotos = [
  {
    image:
      "/uploads/crew-container.jpeg",
    title: "Our packing crew with the loaded container",
    caption: "The team that packs, loads and secures every item before it leaves your doorstep.",
  },
  {
    image:
      "/uploads/crew-ready.jpeg",
    title: "Shifting crew ready for a house move",
    caption: "Uniformed crews arrive on time with packing material, tools and a clear plan for the day.",
  },
  {
    image:
      "/uploads/hero-home.jpeg",
    title: "Crew unloading at a customer's home",
    caption: "Our branded truck and uniformed team delivering box by box, with the family watching their move go smoothly.",
  },
];